import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { UserType } from "../types/login.type";
import axios from "axios";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

const setOnboardingModalDismissed = async ({ token }: UserType) => {
  try {
    const response = await axios.patch(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/users/onboarding-modal-dismissed`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);
    throw new Error(message);
  }
};

export default setOnboardingModalDismissed;
